<template>
    <div class="home-useful">
        <content-header class="home-content home-content-header" text="Полезное"/>
        <useful-cards/>
    </div>
</template>
<script>

import ContentHeader from '@/components/content/ContentHeader.vue'
import UsefulCards from '@/components/useful/UsefulCards.vue';

export default{
    name: 'HomeImportant',
    components: {
        ContentHeader,
        UsefulCards
    }
}

</script>